export default __webpack_public_path__ + "static/media/joystickIcon.5604c168.svg";